export default "__VITE_ASSET__DsvugvXd__"